<template>
    <el-dialog  :append-to-body='true' class="resource_add_cla" @close="onCancel" :title="title" :visible.sync="dialog_visible">
      <div>
       <el-form ref="formValidate" :model="params" :rules="rules"  label-width="140px">
          <el-row :gutter="gutter">
            <el-col :span="12">
                 <el-form-item  :label="$t('common.name')"  prop="name">
                  <el-input  v-model="params.name"  :placeholder="$t('common.nameRequire')"></el-input>
                </el-form-item >
            </el-col>
            <el-col :span="12">
                <el-form-item  :label="$t('resource.resourceType')" prop="resourceType">
                  <zk-dictionary-select type="resourceType" v-model="params.resourceType" style="">
                  </zk-dictionary-select>
              </el-form-item >
            </el-col>
          </el-row>

          <el-row  v-if="params.resourceType+''=== '5'|| params.resourceType+''==='1'" :gutter="gutter">
              <el-col :span="24">
                  <el-form-item  label="URL" prop="url">
                    <el-input  v-model="params.url" :placeholder="$t('resource.urlRequire')"></el-input>
                  </el-form-item >
              </el-col>
          </el-row>

          <el-row :gutter="gutter">
                  <el-row :gutter="gutter">
                    <el-col :span="12">
                      <el-form-item :label="$t('common.status')" prop="status">
                        <zk-dictionary-select type="status" v-model="params.status" style="widith:155px;"
                        :placeholder="$t('common.select')"></zk-dictionary-select>
                      </el-form-item>
                    </el-col>

             <el-col :span="12">
                  <el-form-item  :label="$t('common.i18nKey')" prop="i18nKey">
                    <el-input  v-model="params.i18nKey" :placeholder="$t('common.i18nKeyRequire')"></el-input>
                  </el-form-item >
              </el-col>
            </el-row>

        <el-row :gutter="gutter">
            <el-col :span="12">
                    <el-form-item :label="$t('resource.sortNo')" prop="sortNo">
                      <el-input v-model="params.sortNo" :placeholder="$t('resource.intRequire')"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12"  v-if="params.resourceType+''!== '5'" >
                    <el-form-item  :label="$t('resource.icon')" prop="icon">
                      <el-input v-model="params.icon" placeholder=""></el-input>
                    </el-form-item>
                    <div style="text:center">
                       <a target="_blank" href="https://fontawesome.com/icons">Font Awesome Free 5.8.2</a>
                    </div>
                  </el-col>
                </el-row>
        </el-row>

          <el-row :gutter="gutter">

            <el-col :span="12"  v-if="params.resourceType+''=== '2'|| params.resourceType+''==='3'|| params.resourceType+''==='4'" >
              <el-form-item :label="$t('resource.resourceEvent')" prop="resourceEvent">
                <el-input v-model="params.resourceEvent" placeholder=""></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12"  v-if="params.resourceType+''=== '1'" >
              <el-form-item :label="$t('resource.routerName')" prop="routerName">
                <el-input v-model="params.routerName" :placeholder="$t('resource.routerNameRule')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="gutter" v-if="params.resourceType+''=== '2' || params.resourceType+''=== '3'">
             <el-col :span="12">
              <el-form-item :label="$t('resource.btnGroup')" prop="groupName">
                <el-input v-model="params.groupName" :placeholder="$t('resource.btnGroupRequire')"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$t('resource.btnType')" prop="buttonType">
                <el-select v-model="params.buttonType" :placeholder="$t('resource.btnTypeRequire')">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            </el-row>

            <el-row :gutter="gutter" v-if="params.resourceType+''=== '2' || params.resourceType+''=== '3'">
             <el-col :span="12">
              <el-form-item :label="$t('resource.btnStyle')" prop="buttonStyle">
                <el-select v-model="params.buttonStyle" :placeholder="$t('resource.btnStyleRequire')">
                  <el-option
                    v-for="item in optionStyle"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

              <el-col :span="12"   >
                <el-form-item :label="$t('resource.btnEffect')">
                  <el-button :round="params.buttonStyle==='round'" :icon="params.icon + ' zk-icon-'+params.icon"  :circle="params.buttonStyle==='circle'" :plain="params.buttonStyle==='plain'" :type="params.buttonType" >{{params.name}}</el-button>
                </el-form-item>
              </el-col>
           </el-row>

          <el-row :gutter="gutter">
             <el-col :span="24">
               <el-form-item label-width="150px" :label="$t('resource.parentResource')" prop="parentId">
                  <zk-resource-tree ref="resTree" @nodeClick="nodeClick" :parentId="params.parentId" :treeData="treeData"></zk-resource-tree>
               </el-form-item>
             </el-col>
          </el-row>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="save()">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>
</template>
<script>
import {add, update} from '../../../services/resource.js'
export default {
  name: 'addOrUpdateResource',
  data () {
    let params = {
      id: '',
      name: '',
      resourceType: '',
      url: '',
      sortNo: null,
      icon: '',
      status: '1',
      resourceEvent: '',
      parentId: '',
      routerName: '',
      buttonType: '',
      groupName: '',
      i18nKey: '',
      buttonStyle: ''
    }
    let options = [{
      label: this.$t('resource.default'),
      value: ''
    }, {
      label: this.$t('resource.primary'),
      value: 'primary'
    }, {
      label: this.$t('resource.success'),
      value: 'success'
    }, {
      label: this.$t('resource.info'),
      value: 'info'
    }, {
      label: this.$t('resource.warning'),
      value: 'warning'
    }, {
      label: this.$t('resource.danger'),
      value: 'danger'
    }, {
      label: this.$t('resource.text'),
      value: 'text'
    }]
    let optionStyle = [{
      label: this.$t('resource.default'),
      value: ''
    }, {
      label: this.$t('resource.plain'),
      value: 'plain'
    }, {
      label: this.$t('resource.round'),
      value: 'round'
    }, {
      label: this.$t('resource.circle'),
      value: 'circle'
    }]
    let checkResourceType = (rule, value, callback) => {
      if (undefined || !value) {
        return callback(new Error(this.$t('resource.typeRequire')))
      } else {
        callback()
      }
    }
    let checkStatus = (rule, value, callback) => {
      if (undefined || !(value + '')) {
        return callback(new Error(this.$t('common.statusRequire')))
      } else {
        callback()
      }
    }
    let checkSortNo = (rule, value, callback) => {
      if (undefined || !value) {
        return callback(new Error(this.$t('resource.sortNoRequire')))
      } else if (!/^[0-9]*$/.test(value)) {
        return callback(new Error(this.$t('resource.intRequire')))
      } else {
        callback()
      }
    }
    let checkKeys = (checkKeys, value) => {
      let flag = false
      if (!checkKeys) {
        checkKeys = []
      }
      checkKeys.forEach(item => {
        if (item === value) {
          flag = true
        }
      })
      return flag
    }
    let checkParentId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('resource.parentRequire')))
      } else if (this.form && this.form.id === value) { // 父级资源不允许是资源自身
        return callback(new Error(this.$t('resource.parentRule1')))
      } else if (checkKeys(this.checkKeys, value)) { // 父资源不能是当前资源的子资源
        return callback(new Error(this.$t('resource.parentRule2')))
      } else {
        callback()
      }
    }

    let rules = {
      name: [{ required: true, message: this.$t('common.nameRequire'), trigger: 'blur' }],
      i18nKey: [{ required: true, message: this.$t('common.i18nKeyRequire'), trigger: 'blur' }],
      resourceType: [{ required: true, validator: checkResourceType, trigger: 'blur, change,onchange' }],
      status: [{ required: true, validator: checkStatus, trigger: 'blur,change,onchange' }],
      sortNo: [{ required: true, validator: checkSortNo, trigger: 'blur' }],
      parentId: [{ required: true, validator: checkParentId, trigger: 'blur, change, check' }],
      resourceEvent: [{ required: true, message: this.$t('resource.resourceEventRequire'), trigger: 'blur' }]
    }
    return {
      params,
      rules,
      options,
      optionStyle,
      gutter: 25,
      dialog_visible: this.visible,
      title: this.isUpdate ? this.$t('resource.updateResource') : this.$t('resource.addResource'),
      checkKeys: []
    }
  },
  methods: {
    save () {
      let _self = this
      this.params.parentId = this.$refs.resTree.getCurrentKey()

      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            if (!_self.isUpdate) {
              this.$delete(this.params, 'id')
              resolve(add(_self.params))
            } else {
              resolve(update(_self.params))
            }
          }
        })
      }).then((data) => {
        if (data.code === '00000000') {
          this.$message.info(`${this.title} ` + this.$t('common.success'))
          this.dialog_visible = false
          this.$emit('queryUserResourceTree')
        } else {
          this.$message.error(data.message)
          this.dialog_visible = false
        }
      }).catch((data) => {
        this.$message.error(data.message)
      })
    },
    onCancel () {
      this.dialog_visible = false
      this.resetFields()
    },
    nodeClick (selectId) {
      this.params.parentId = selectId
      if (this.params.id !== '') {
        this.checkKeys = this.$refs.resTree.getCheckedKeys(this.$refs.resTree.getNodeById(this.params.id).data)
      } else {
        this.checkKeys = []
      }
    },
    resetFields () {
      this.$refs.formValidate.resetFields()
      if (this.isUpdate) {
        for (let key in this.form) {
          if (this.params.hasOwnProperty(key)) {
            this.params[key] = this.form[key]
          }
        }
      } else {
        this.initParams()
      }
    },
    initParams () {
      this.params.id = ''
      this.params.name = ''
      this.params.resourceType = ''
      this.params.url = ''
      this.params.sortNo = null
      this.params.icon = ''
      this.params.status = ''
      this.params.resourceEvent = ''
      this.params.parentId = ''
      this.params.routerName = ''
      this.params.i18nKey = ''
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    isUpdate: {
      type: Boolean,
      default: true
    },
    treeData: {
      type: Array,
      default: function () {
        return []
      }
    },
    form: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    visible (val) {
      this.dialog_visible = val
    },
    dialog_visible (val) {
      if (val === false) {
        this.$emit('dioClose')
      }
    },
    'params.resourceType' (val) {
      try {
        this.$refs.formValidate.clearValidate()
      } catch (error) {

      }
    },
    isUpdate (val) {
      this.title = val ? this.$t('resource.updateResource') : this.$t('resource.addResource')
    },
    form (newValue, oldValue) {
      if (this.isUpdate) {
        for (let key in newValue) {
          if (this.params.hasOwnProperty(key)) {
            this.params[key] = newValue[key]
          }
        }
      } else {
        this.initParams()
      }
    }
  }
}
</script>

<style lang="less">
.resource_add_cla{
  .el-select{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/addOrUpdateResource/src/main.vue